import { render, staticRenderFns } from "./SeriesWrapper.vue?vue&type=template&id=a792f66a&scoped=true"
import script from "./SeriesWrapper.vue?vue&type=script&lang=js"
export * from "./SeriesWrapper.vue?vue&type=script&lang=js"
import style0 from "./SeriesWrapper.vue?vue&type=style&index=0&id=a792f66a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a792f66a",
  null
  
)

export default component.exports